<template>
  <service-category-card
    @selected="categorySelectedInComponent"
    serviceCategoryType="early-detection"
    :heading="
      store.getters.translate(
        'category-services-appointment-early-detection-heading'
      )
    "
    :options="getOptions"
  ></service-category-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { index } from "@/store/index";
import ServiceCategoryCard from "@/components/ServiceCategoryCard.vue";
import { getServiceCategoryTypeFromString } from "@/store/appointment-selection";

export default defineComponent({
  components: { ServiceCategoryCard },
  name: "ServiceCategoryEarlyDetection",
  emits: ["categorySelected"],
  data() {
    return {
      store: index
    };
  },
  computed: {
    getOptions: function() {
      let options = [""];
      options = [
        this.store.getters.translate("category-service-card-psa-heading"),
        this.store.getters.translate("category-service-card-fit-heading"),
        this.store.getters.translate("category-service-card-mole-screening-heading"),
      ];
      return options;
    }
  },
  methods: {
    categorySelectedInComponent() {
      this.$emit(
        "categorySelected",
        getServiceCategoryTypeFromString("early-detection")
      );
    }
  }
});
</script>
